const config = {
  rowSelection: true,
  listTitle: '广告列表',
  columns: [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 180,
      ellipsis: true
    },
    {
      title: '排序',
      dataIndex: 'sortNumber',
      width: 100,
      ellipsis: true
    },
    {
      title: '所属二级菜单',
      dataIndex: 'parentName',
      width: 120,
      ellipsis: true
    },
    {
      title: '描述信息',
      dataIndex: 'descInfo',
      width: 150,
      ellipsis: true
    },
    {
      title: '白名单',
      dataIndex: 'confDtlRelWlists',
      width: 150,
      render:'confDtlRelWlistsRender',
      ellipsis: true
    },
    {
      title: '是否启用',
      dataIndex: 'status',
      render: "statusFn",
      width: 120
    },
    {
      title: '生效时间',
      dataIndex: 'startTime',
      width: 160,
      itemType: 'dateTime',
      ellipsis: true
    },
    {
      title: '失效时间',
      dataIndex: 'endTime',
      itemType: 'dateTime',
      width: 160,
      ellipsis: true
    },
    {
      title: '更新人',
      dataIndex: 'modifiedByName',
      width: 110,
      ellipsis: true
    },
    {
      title: '更新时间',
      dataIndex: 'lastUpdatedTime',
      itemType: "dateTime",
      width: 160,
      ellipsis: true
    },
    {
      title: '操作',
      dataIndex: '#',
      width: 200,
      render: 'operationFn',
      fixed: 'right',
    },
  ],
  search: false,
  footer: [
    {
      label: "批量新增",
      type: "primary",
      events: ["onClick:onAdd"]
    },
    {
      label: "批量删除",
      type: "primary",
      events: ["onClick:onBatchDelete"]
    }
  ]
}

export default config
